<template>
	<div>
		<v-layout wrap py-3 px-3>
			<v-flex xs6 px-2>
				<span class="caption">Cod. Cta. co</span>
				<BaseInput
					:height="33"
					v-model="model.account"
					disabled
				/>
			</v-flex>
			<v-flex xs6 px-2>
				<span class="caption">Cuenta Contable</span>
				<BaseSelect
					autocomplete
					return-object
					label="Cod. Contable"
					item-text="fullName"
					item-value="id"
					:height="33"
					:items="accounts"
					:value="account.code"
					@input="setAccountData"
					v-model="model.accountingAccountId"
				/>
				<span class="caption error--text"
					v-if="$v.model.account.$invalid">
					La cuenta es requerida.
				</span>
			</v-flex>
			<v-flex xs12 px-2>
				<span class="caption">Referencia</span>
				<BaseInput
					:height="33"
					v-model="model.reference"
				/>
			</v-flex>
			<v-flex xs12 px-2>
				<span class="caption">Concepto de Movimiento</span>
				<BaseInput
					:height="33"
					v-model="model.concept"
				/>
			</v-flex>
			<v-flex xs12 px-2>
				<span class="caption">Centro de Costos</span>
				<BaseSelect
					item-text="name"
					item-value="id"
					:height="33"
					:items="costCenters"
					v-model="model.costCenterId"
				/>
			</v-flex>
			<span class="caption error--text"
			v-if="$v.model.costCenterId.$invalid">
				Centro de costo es requerido.
			</span>
			<v-flex xs12 px-2 mt-3>
				<span class="caption">Importe</span>
				<BaseInput
					:height="33"
					type="number"
					v-model.number="model.amount"
				/>
				<span class="caption error--text"
					v-if="$v.model.amount.$invalid">
					El importe es requerido.
				</span>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="$emit('save', model)"
			>
			</modal-sidebar-button>
		</section>
	</div>
</template>

<script>
	import { required } from 'vuelidate/lib/validators';
	import helper from '@/shared/helper';

	const { debounce } = helper;

	async function created() {
		await Promise.all([
			this.loadCostCenters(),
			this.searchAccount(),
		]);
	}

	function disabledBtn() {
		return this.$v.$invalid;
	}

	async function loadCostCenters() {
		({ data: this.costCenters } = await this.$http.get(
			`cost-center/${this.subsidiaryId}/subsidiary`));
	}

	async function searchAccount() {
		const params = { status: 1 };
		const url = `accounting-plan/${this.subsidiaryId}/subsidiary`;
		try {
			({ data: this.accounts } = await this.$http.get(url, { params }));
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				this.showGenericError(err.data.message);
			}
		}
	}

	function setAccountData(accountData) {
		this.account = { ...accountData };
		this.model.account = this.account.code;
		this.model.accountingAccountId = this.account.id;
	}

	function validations() {
		return {
			model: {
				account: { required },
				amount: { required },
				costCenterId: { required },
			},
		};
	}

	function data() {
		return {
			account: {},
			accounts: [],
			costCenters: [],
			disabled: false,
		};
	}

	export default {
		name: 'journal-detail-form',
		components: {
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
		},
		computed: {
			disabledBtn,
		},
		created,
		data,
		methods: {
			loadCostCenters,
			searchAccount: debounce(searchAccount),
			setAccountData,
		},
		props: {
			loading: {
				default: false,
				type: Boolean,
			},
			subsidiaryId: [Number, String],
			model: {
				type: Object,
				default: () => {},
			},
		},
		validations,
	};
</script>



// WEBPACK FOOTER //
// src/components/journal/journal-detail-form.vue